<div *ngIf="checkboxModel" [formGroup]="form">
  <ws10-form-checkbox
  [checkboxModel]="checkboxModel"
  [formControlName]="formControlName"
  [required]="formField.required ? '' : null"
 ></ws10-form-checkbox>
</div>
